module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._l((_vm.items2), function(item) {
    return _c('li', {
      class: ['breadcrumb-item', item.__active ? 'active' : null],
      on: {
        "click": function($event) {
          _vm.onclick(item)
        }
      }
    }, [(item.active) ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }) : _c('b-link', {
      attrs: {
        "to": item.to,
        "href": item.href || item.link
      },
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })], 1)
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab1afdbc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/breadcrumb.vue
// module id = 255
// module chunks = 0